/* eslint-disable */
import {Service} from 'components/Shared/server';
import {ProductlistViewProduct} from 'models/ProductlistViewProduct';
import {ProductlistFilterResponse} from 'models/ProductlistFilterResponse';


export const routeGetProducts = (webCatalog: string, page?: number, order?: number, query?: {[key: string]: string}) => Service.appendQueryString(`/api/productlist/${encodeURIComponent(webCatalog)}/products?page=${page}&order=${order}`, query);
export function getProducts(webCatalog: string, page?: number, order?: number, query?: {[key: string]: string}): Promise<ProductlistViewProduct[]> {
  return Service.get<ProductlistViewProduct[]>({
    url: routeGetProducts(webCatalog, page, order, query)
  });
}

export const routeGetSearch = (phrase: string, page?: number, order?: number, query?: {[key: string]: string}) => Service.appendQueryString(`/api/productlist/search?phrase=${encodeURIComponent(phrase)}&page=${page}&order=${order}`, query);
export function getSearch(phrase: string, page?: number, order?: number, query?: {[key: string]: string}): Promise<ProductlistViewProduct[]> {
  return Service.get<ProductlistViewProduct[]>({
    url: routeGetSearch(phrase, page, order, query)
  });
}

export const routeGetProductlist = (webCatalog: string, filterOrders: string, page?: number, order?: number, query?: {[key: string]: string}) => Service.appendQueryString(`/api/productlist/${encodeURIComponent(webCatalog)}/productlist?filterOrders=${encodeURIComponent(filterOrders)}&page=${page}&order=${order}`, query);
export function getProductlist(webCatalog: string, filterOrders: string, page?: number, order?: number, query?: {[key: string]: string}): Promise<ProductlistFilterResponse> {
  return Service.get<ProductlistFilterResponse>({
    url: routeGetProductlist(webCatalog, filterOrders, page, order, query)
  });
}
